module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-unknown-3.912e672e.svg";